<template lang="pug">
table.loading-table
  thead
    tr
      th
      th
      th
      th
  tbody
    tr
      td
      td
      td
      td
    tr
      td
      td
      td
      td
    tr
      td
      td
      td
      td
    tr
      td
      td
      td
      td
</template>

<script>
export default {
  name: 'TimeOffBalancesLoadingTable',
};
</script>
